import React, { Component } from "react";
import { connect } from 'react-redux';

import FadeIn from '../global/FadeIn';
import IframeComm from 'react-iframe-comm';
import Logger from "../../functions/logging";
import settings from '../../libs/config';

import PCORE_EVENT from "../../constants/pilotly-player";
import { PlayerType } from "./constants";
import * as helpers from '../../functions/helpers';

import SVODStatus from '../../analytics/analytics-events/SVODStatus';
import { SVODStatusEvent } from '../../analytics/analytics-events/constants';
import speakerIconOn from '../../assets/svod/player-controls/speaker-on.svg';
import speakerIconOff from '../../assets/svod/player-controls/speaker-off.svg';
import { isNumber, isValidJSON } from '../../functions/utils';
import { EnvType } from "./constants";

class VideoPlayer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			triggerUpdateEnvResponse: false,

			postMessageData: {},
			openEndedResponse: '',
			display: true,
			playerLoading: true,
			displayValidationError: false,
			validationError: null,
			startTime: (new Date()).getTime(),

			location: this.props.location,

			timeout: props.timeout ? props.timeout : 250,

			harnessWidth: 0,
			harnessHeight: 0,

			volumeSliderOff: false,
			volumeLevel: -1,

			lastVideoReady: false
		};

		const params = this.returnParams(this.props);
		const locale = props.intl && props.intl.locale ? props.intl.locale : "en";

		let displayControls = true;
		if (this.props.environment === EnvType.PEACOCK || this.props.environment === EnvType.APPLETV) {
			displayControls = false;
		}

		const duration = props.video ? props.video.video.duration : 0;
		const playerUrl =
			params.portal_player_url + 
			// "?type=question" +
			// "&st=" + (props.question ? props.question.start_time : "") +
			"?st=0" +
			// "&et=" + (props.question ? props.question.end_time : "") +
			`&et=` + duration + 
			"&language=" + locale +
			// "&language=en";
			"&interactive=0" + 
			(props.isSeekEnabled ? "&seekEnabled=1" : "") +
			"&controls=" + (props.watchpage && displayControls ? "1" : "0") + 
			`${props.isDynamicBillboard ? '' : '&mute=1'}
			${props.svod_id ? `&svod_id=${props.svod_id}&ad_units=1` : ''}`;

			// add additional parameters for controls and the volume for initial loading
			// mute=1 -> that is muted
			// controls=0 -> no controls show

		Logger.log("constructor Player Url:", playerUrl);

		this.attributes = {
			serializeMessage: false,
			src: playerUrl,
			width: "100%",
			height: "100%",
			frameBorder: 0,
			scrolling: "no",
			allowFullScreen: true,
			targetOrigin: 'pilot.ly',
			allow: 'encrypted-media; autoplay'
		};
		this.adChoiceMethodTriggered = false;
		this.isPlayerInit = false;

		this.onReady = this.onReady.bind(this);
		this.onReceiveMessage = this.onReceiveMessage.bind(this);
		this.returnPlayerData = this.returnPlayerData.bind(this);
		this.handleAdChoiceMethods = this.handleAdChoiceMethods.bind(this);
		this.handlePlayerState = this.handlePlayerState.bind(this);
		this.handleError = this.handleError.bind(this);
		this.updateVideoPlayer = this.updateVideoPlayer.bind(this);
		this.updateEnvironmentResponse = this.updateEnvironmentResponse.bind(this);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.postMessageData && this.state.postMessageData.method == "seekTo") {
			this.props.playerControlsPlay();
		}

		if (!this.state.playerLoading && (this.props.environment === EnvType.NETFLIX)) {
			let videoCover = document.getElementById("video-cover");
			if (videoCover !== null) {
				videoCover.style.opacity = 0;
			}
		}

		if (prevProps.video 
			&& this.props.video 
			&& prevProps.video._id !== this.props.video._id
		) {
			this.updateVideoPlayer('changeVideo', true, this.props.video);
		}

		if (this.props.triggerAdChoiceMethod && !this.adChoiceMethodTriggered) {
			this.adChoiceMethodTriggered = true;
			this.handleAdChoiceMethods(this.props.adUnitEvent);
		}
	}
	
	componentDidMount() {
		this.props.onRef(this);

		if (this.props.volume.volume) {
			this.setState({volumeSliderOff: false });
		}

		if (this.volumeSlider) {
			this.volumeSlider.addEventListener('input', (event) => {
				let newVolume = (this.volumeSlider.value / 100);
				this.updateVideoPlayer("volume", newVolume);
				if (newVolume === 0) {
					this.setState({volumeSliderOff: true });
				} else {
					this.setState({volumeSliderOff: false });
				}
			});
		}

		window.addEventListener("resize", () => {
			const playerRef = this._questionPlayer;
			let { harnessHeight, harnessWidth } = this.state;
	
			if (playerRef && playerRef._frame) {
				if (this.props.sizingMode === "FULLSCREEN") {
					harnessHeight = window.innerHeight;
					harnessWidth = harnessHeight * .5625;			
				} else {
					harnessWidth = playerRef._frame.offsetWidth;
					harnessHeight = harnessWidth * .5625;
				}
			}

			this.setState({ harnessHeight, harnessWidth });
		});

		this.updateEnvironmentResponse(this.props.video, 0);
		this._updateEnvResponseInterval = setInterval(() => this.setState({ triggerUpdateEnvResponse: true }), 3000);
	}

	componentWillUnmount() {
		this.props.onRef(undefined);
		clearInterval(this._updateEnvResponseInterval);

		this.adChoiceMethodTriggered = false;
	}

	updateEnvironmentResponse(videoObj, currentTime) {
		if (videoObj) {
			this.props.eventHandler({ 
				data: { 
					event_type: "update_asset_watch_progress", 
					current_time: currentTime, 
					video: videoObj,
					asset_name: this.props.video.name, 
					asset_id: this.props.video._id,
					time: Date.now() 
				}
			});
			this.setState({ triggerUpdateEnvResponse: false });
		}
	}

	// iframe has loaded
	onReady() {
		Logger.log(this.constructor.name, "onReady()");

		/* Google analytics event - Video ready */
		let eventName = helpers.getEventName(this.props.location);
		let svodStatus = new SVODStatus(eventName, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = 'start';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);
	}

	// parent received a message from iframe
	onReceiveMessage(event) {
		console.log(this.constructor.name, "onReceiveMessage() EVENT DATA:", event.data);
		if (!event.data) {
			Logger.log(this.constructor.name, "onReceiveMessage()", 'no event data provided with message', event.data);
		}

		const data = event.data && typeof event.data === 'string' && isValidJSON(event.data) ? JSON.parse(event.data) : event.data;
		const eventType = data.eventType || "default";
		// Logger.log(this.constructor.name, "onReceiveMessage()", 'event type', eventType, 'received an event', data);

		switch (eventType) {
			case "interactiveState": {
				// Logger.log(this.constructor.name, "onReceiveMessage()", 'Handling InteractiveState', data);
				// this.handleInteractiveState(data);
				break;
			}
			case "mediaState": {
				// Logger.log(this.constructor.name, "onReceiveMessage()", 'Handling MediaState', data.message);

				if (data.message.state == "time_update" && this.props.updateSeekBarTime) {
					this.props.updateSeekBarTime(data.message.time);
				}

				if (this.state.triggerUpdateEnvResponse) {
					this.updateEnvironmentResponse(this.props.video, data.message.time);
				}

				if (data.message.status === "onPlay()") {
					Logger.log(this.constructor.name, "onReceiveMessage() onPlay()", data.message);
					
					if (this.props.setPlay) this.props.setPlay();
					if (this.props.removeLoader) this.props.removeLoader();

					if (this.props.sizingMode === "FULLSCREEN") {
						if (this.props.volumeLevel !== this.state.volumeLevel) {
							this.updateVideoPlayer("volume", this.props.volumeLevel);
							this.setState({ volumeLevel: this.props.volumeLevel });
						}
					} else {
						this.updateVideoPlayer("volume", this.props.volume.volume);
					}
				}

				if (data.message.status === "onPause()") {
					/* Google analytics event - Video completed */
					let eventName = helpers.getEventName(this.props.location);

					let svodStatus = new SVODStatus(eventName, '', '', false, false, true, false);
					svodStatus.gaTracker = this.props.tracker;
					svodStatus.state = this.state;
					svodStatus.label = 'pause';
					this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

					if (this.props.environment === EnvType.APPLETV && this.props.setPause) this.props.setPause();
				}

				if (data.message.status === "onFirstFrame()") {
					if (this.props.video && this.props.targetAssetId === this.props.video._id
						|| (this.props.playAd && this.props.playerType !== PlayerType.adPlayer)
					) {
						if (this.props.playerControlsPause) this.props.playerControlsPause();
					}

					if (this.props.triggerRatingAnimation) this.props.triggerRatingAnimation();
					this.setState({active: true});
				}

				if (data.message.status === "display_ads" && this.props.handleAdUnitInit) {
					// this currently triggers the ad choice component for Peacock (Infillion - ad choice component)
					this.props.handleAdUnitInit(data);
				}
				break;
			}
			case "playerState": {
				Logger.log(this.constructor.name, "onReceiveMessage()", 'Handling PlayerState', data);
				this.handlePlayerState(data);
				break;
			}
			case "analyticsEvent": {
				// Logger.log(this.constructor.name, "onReceiveMessage()", 'Handling Analytics Event', data);
				// this.handleAnalyticsEvent(data);
				break;
			}
			default: {
				break;
			}
		}
	}

	handleAdChoiceMethods(eventType) {
		let postMessageData = {};

		switch (eventType) {
			case "optIn": case "optOut": {
				postMessageData = { event: "ad_unit_complete", state: eventType };
				break;
			}
		}
		this.setState({ postMessageData });
	}

	hideLoader = () => {
		setTimeout(() => {
			this.setState({ playerLoading: false });
		}, 1000);
	}

	handleError(errorData) {
		Logger.log(this.constructor.name, "handleError()", errorData);
	
		/* Google analytics event - Video Player Error */
		let labelData = `${errorData.code}-` + errorData.type + "-" + errorData.os + "-" + errorData.browser + "-" + `timecode:${errorData.timecode}` + `-videoID:${this.props.video ? this.props.video._id : "no-videoID"}`;
		let playerInfo = JSON.parse(errorData.playerInfo);
		if (playerInfo && playerInfo.playListFile) labelData += `-${playerInfo.playListFile}`;

		let svodStatus = new SVODStatus(SVODStatusEvent.SVODPLAYER_ERROR, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.label = labelData;

		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);
	}

	handlePlayerState(data) {
		const event = data.message.event;
		Logger.log(this.constructor.name, "handlePlayerState()", event);

		switch (event) {
			case PCORE_EVENT.CLOSE_PLAYER: {
				// this.closePlayer('close');
				break;
			}
			case PCORE_EVENT.READY: {
				const playerRef = this._questionPlayer;
				let { harnessHeight, harnessWidth, postMessageData } = this.state;
				let updatedPostMessageData = this.returnPlayerData(this.props);
				if (!this.isPlayerInit && updatedPostMessageData.event === 'init_player') {
					this.isPlayerInit = true;
				}
				else if (this.isPlayerInit) {
					delete updatedPostMessageData.event;
				}

				if (!helpers.areObjectsTheSame(postMessageData, updatedPostMessageData)
					&& postMessageData.method !== 'updateVolume'
					&& postMessageData.method !== 'togglePlay'
					&& postMessageData.method !== 'seekTo'
				) {
					if (playerRef && playerRef._frame) {
						if (this.props.sizingMode === "FULLSCREEN") {
							harnessHeight = window.innerHeight;
							harnessWidth = harnessHeight * .5625;			
						}
						else {
							harnessWidth = playerRef._frame.offsetWidth;
							harnessHeight = harnessWidth * .5625;
						}
					}

					this.setState({ harnessHeight, harnessWidth, postMessageData: updatedPostMessageData});
				}

				if (this.props.videoReady) this.props.videoReady();
				this.hideLoader();
				break;
			}		
			case PCORE_EVENT.COMPLETE: {
				/* Google analytics event - Video completed */
				let eventName = helpers.getEventName(this.props.location);
				let svodStatus = new SVODStatus(eventName, '', '', false, false, true, false);
				svodStatus.gaTracker = this.props.tracker;
				svodStatus.state = this.state;
				svodStatus.label = 'complete';
				this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

				this.updateEnvironmentResponse(this.props.video, data.message.value);

				if (this.props.video && this.props.targetAssetId === this.props.video._id) {
					this.props.eventHandler({ data: { event_type: "watched_target_content"} });
				}			

				if ((this.props.isAdPlayback && this.props.isAdPlayerLayer) || 
					(!this.props.isAdPlayback && !this.props.isAdPlayerLayer)) {
					this.props.videoEnded();
				}
				break;
			}
			case PCORE_EVENT.SETUP_ERROR:
			case PCORE_EVENT.ERROR: {
				this.handleError(data.message);
				break;
			}
		}
	}

	returnPlayerData(props) {
		Logger.log("for user", this.props.currentUser.user_profile_privacy);
		
		let user = {
			platform: "aPlatform",
			email: this.props.currentUser.email,
			userId: this.props.currentUser.user_id,
			firstlogin: this.props.currentUser.firstlogin,
			firstscreening: false,
			mobile: false,
			details: {
				profile: {
					firstname: this.props.currentUser.firstname,
					lastname: this.props.currentUser.lastname
				},
				username: this.props.currentUser.username,
				privacy: {
					alert_email: this.props.currentUser.email,
					feedback_basic: this.props.currentUser.user_profile_privacy.feedback_basic,
					feedback_pro: this.props.currentUser.user_profile_privacy.feedback_pro,
					media_captions: this.props.currentUser.user_profile_privacy.media_captions,
					media_hd: this.props.currentUser.user_profile_privacy.media_hd
				},
				monitor: {
					last_sub_view: this.props.currentUser.user_monitor.last_sub_view,
					last_view: this.props.currentUser.user_monitor.last_view,
					survey_waiting: this.props.currentUser.user_monitor.survey_waiting
				},
				subSet: [],
				avatar: this.props.currentUser.avatar,
			}
		};

		let videoURL;
		if (this.props.isAdPlayerLayer) {
			let videoObj = this.props.promoAsset;
			videoURL = videoObj.video.url; 
		} else {
			videoURL = this.props.video ? this.props.video.video.url : '';
		}

		let meta = {
			duration: this.props.video ? this.props.video.video.duration : 0,
			url: videoURL,
		};

		if (this.props.adChoiceEnabled) {
			const { svod_env } = this.props.fetchedGroup;
			meta.ad_units = svod_env.ad_units;
		}

		let event = "init_player"; 
		return { user, meta, event };
	}

	updateVideoPlayer = (type, level = true, videoObj = {}) => {
		const { isDynamicBillboard } = this.props;
		if (type === "forcePause") {
			this.setState({ postMessageData: { event: "method_call", method: 'togglePlay', value: "pause" } });
		}
		else if (type === "forcePlay") {
			this.setState({ postMessageData: { event: "method_call", method: 'togglePlay', value: "play" } });
		}
		
		// TO-DO update volume to be consistent across environments
		else if (type === "volume" && isNumber(level)) {   
			this.setState({ postMessageData: { event: "method_call", method: 'updateVolume', value: level } });
		}
		else if (type === "volume") {
			// for apple's dynamic billboard we need to wait until the volumn is enabled to start playing the video
			// when the player is ready to be played the volume will set automatically
			if (this.props.videoVolumeReady && isDynamicBillboard) this.props.videoVolumeReady(this.state.videoObj, this.state.postMessageData);
			
			if (level) {
				this.setState({ postMessageData: { event: "method_call", method: 'updateVolume', value: 1 }});
			} else { 
				this.setState({ postMessageData: { event: "method_call", method: 'updateVolume', value: 0 }});
			}
		}  else if (type === "seek") {
			// value is the new location (in seconds) to seek to
			this.setState({ postMessageData: { event: "method_call", method: 'seekTo', value: level }});
		}
		else if (type === "changeVideo") {
			let user = {
				platform: "aPlatform", // grab from parent container
				email: this.props.currentUser.email,
				userId: this.props.currentUser.user_id,
				firstlogin: this.props.currentUser.firstlogin,
				firstscreening: false,
				mobile: false,
				details: {
					profile: {
						firstname: this.props.currentUser.firstname,
						lastname: this.props.currentUser.lastname
					},
					username: this.props.currentUser.username,
					privacy: {
						alert_email: this.props.currentUser.email,
						feedback_basic: this.props.currentUser.user_profile_privacy.feedback_basic,
						feedback_pro: this.props.currentUser.user_profile_privacy.feedback_pro,
						media_captions: this.props.currentUser.user_profile_privacy.media_captions,
						media_hd: this.props.currentUser.user_profile_privacy.media_hd
					},
					monitor: {
						last_sub_view: this.props.currentUser.user_monitor.last_sub_view,
						last_view: this.props.currentUser.user_monitor.last_view,
						survey_waiting: this.props.currentUser.user_monitor.survey_waiting
					},
					subSet: [],
					avatar: this.props.currentUser.avatar,
				}
			};

			let meta = {
				duration: videoObj.video.duration,
				url: videoObj.video.url,
			};

			const timeout = isDynamicBillboard ? 1500 : 0;
			if (this.props.displayLoader) { this.props.displayLoader(); }
			setTimeout(() => {
				this.setState({ videoObj, postMessageData: { event: "method_call", method: 'changeVideo', value: { user, meta } } });
			}, timeout);
		}
	}

	returnParams(props) {
		let group_id = null;
		let panelSegmentIndex = null;
		let portal_player_url = null;
		if (props.targetParams &&
			props.targetParams.gid
		) {
			group_id = props.targetParams.gid;
		}
		else if (props.fetchedGroup
			&& props.fetchedGroup._id
		) {
			group_id = props.fetchedGroup._id;
		}

		panelSegmentIndex = props.targetParams.panelSegmentIndex || props.targetParams.ps || '0';
		portal_player_url = settings.portal_player_base + "/players/slave_player.html";

		return {
			group_id,
			panelSegmentIndex,
			portal_player_url,
		};
	}

	renderVideo() {
		this.attributes['height'] = this.state.harnessHeight + 'px';
		if (this.props.environment === EnvType.PEACOCK) {
			this.attributes['height'] = '100%';
		}

		console.log("POST MESSAGE DATA:", this.state.postMessageData);
		return (
			<div id="questionPlayer" className="gf_player onOffTrans" style={{ zIndex: "0px !important" }}>
				<IframeComm
					ref={(node) => this._questionPlayer = node}
					attributes={this.attributes}
					postMessageData={this.state.postMessageData}
					handleReady={this.onReady}
					handleReceiveMessage={this.onReceiveMessage}
				/>

				{this.props.environment === EnvType.PEACOCK && (
					<div className="volume-control-container">
						<input className="volume-control" type="range" min="0" max="100" ref={ref => (this.volumeSlider = ref)} />
						<img src={this.state.volumeSliderOff ? speakerIconOff : speakerIconOn} />
					</div>
				)}
			</div>
		);
	}

	render() {
		const { className } = this.props;
		return (
			
			<FadeIn id="svod-video" addedClass={`${className || ''}`} timeout={this.state.timeout} hide={!this.state.display} >
				{this.renderVideo()}

				{(this.props.environment === EnvType.NETFLIX && !this.props.watchpage) ? (
					<div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1 }}><img id="video-cover" src={this.props.video.images.thumbnail} alt="" /></div>
				) : (
					<div></div>
				)}

			</FadeIn>
		);
	}
}

const mapStateToProps = (state) => ({
	dropdown: state.SVOD.dropdown,
	volume: state.SVOD.volume,
	currentUser: state.currentUser.currentUser,
	currentUserLocation: state.currentUser.currentUserLocation,
	environment: state.SVOD.environment,
	isSurveyActive: state.SVOD.isSurveyActive,
	targetAssetId: state.SVOD.selectedAssets.targetAssetId,

	// UserDisclaimer: state.currentUser.UserDisclaimer,

	fetchedDistributionList: state.targetProcess.fetchedDistributionList,
	fetchedGroup: state.targetProcess.fetchedGroup,
	fetchedPanel: state.targetProcess.fetchedPanel,
	targetParams: state.targetProcess.targetParams,

	tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
});

const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(VideoPlayer);


// WEBPACK FOOTER //
// ./src/components/svod/video-player.jsx